import { pb } from './api';
import type {
  RequiredVideoConfig,
  VideoProgress,
} from '@/types/required-video';

export async function fetchVideoConfig(
  key: string
): Promise<RequiredVideoConfig> {
  return pb.send(`/api/videos/config/${encodeURIComponent(key)}`, {
    method: 'GET',
  });
}

export async function fetchVideoProgress(key: string): Promise<VideoProgress> {
  return pb.send(`/api/videos/progress/${encodeURIComponent(key)}`, {
    method: 'GET',
  });
}

export type ProgressUpload = {
  video_key: string;
  duration_secs: number;
  seconds_watched: number;
  last_position: number;
};

// keepalive lets the request survive page unload (pagehide / reload). Without
// it, browsers cancel in-flight fetches when the page goes away — so the
// final progress save would never reach the server, and the user starts
// from scratch on the next visit. Always-on keepalive is fine: payload is
// ~200 bytes, well under the 64KB browser cap.
export async function postVideoProgress(
  input: ProgressUpload
): Promise<VideoProgress> {
  return pb.send('/api/videos/progress', {
    method: 'POST',
    body: input,
    keepalive: true,
  });
}
